module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "otherbooks",
    attrs: {
      "id": "adc"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('span', {
    staticClass: "medium"
  }, [_vm._v("ALSO BY NICHOLAS COLERIDGE")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Tunnel Vision")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Around the World in 78 Days")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Shooting Stars")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("The Fashion Conspiracy")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("How I Met My Wife and Other Stories")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Paper Tigers")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("With Friends Like These")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("Streetsmart")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('em', [_vm._v("A Much Married Man")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-281a7124","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9780312382582_epub_adc_r1.vue
// module id = 57
// module chunks = 0